import { customInstanceForCsv } from '@fukuri-admins/apis/client/base/axiosInstance';
import { getGetApiV1ThreeLetterCodeClientAdminsActivationCodeExportUrl } from '@fukuri-admins/apis/client/gen/endpoints';

/**
 * アクティベーションコード CSV ダウンロード
 *
 * @param threeLetterCode - 3文字コード
 * @returns CSVのBlobデータ
 */
export const fetchActivationCodesCsv = (threeLetterCode: string): Promise<Blob> => {
  const url = getGetApiV1ThreeLetterCodeClientAdminsActivationCodeExportUrl(threeLetterCode);
  return customInstanceForCsv({ url, method: 'GET' });
};
